import { ApiMethod, constructFetchFn } from '@utils/api';
import { API } from '@utils/constants';


export const applicationResult = () => (
    constructFetchFn({
        method: ApiMethod.GET,
        url: API.APPLICATION_RESULT
    })
);

export const login = (programId, data) => (
    constructFetchFn({
        method: ApiMethod.POST,
        url: API.USER_LOGIN,
        body: {
            programId,
            data
        },
    })
)

export const logout = () => (
    constructFetchFn({
        method: ApiMethod.POST,
        url: API.USER_LOGOUT,
    })
)

export const userDetail = () => (
    constructFetchFn({
        method: ApiMethod.GET,
        url: API.USER_DETAIL,
    })
)

export const resultPayment = () => (
    constructFetchFn({
        method: ApiMethod.GET,
        url: API.USER_PAYMENT,
    })
)

export const receipt = () => (
    constructFetchFn({
        method: ApiMethod.GET,
        url: API.USER_RECEIPT
    })
)
